
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'switch-list': {
    width: 20,
    height: 20,
    viewBox: '0 0 22 24',
    data: '<path fill-rule="evenodd" clip-rule="evenodd" d="M4 9H8V5H4V9ZM8 14H4V10H8V14ZM8 19H4V15H8V19ZM21 14H9V10H21V14ZM9 19H21V15H9V19ZM9 9V5H21V9H9Z"/>'
  }
})
